import React from "react";
import styled from "styled-components";
import { FixaSwitch } from "@coworker/apprestructured/src/shared/wrappers/FixaSwitch/FixaSwitch";
import Instructions from "../../Instructions";
import profilePreferences from "@coworker/enums/profilePreferences";
import { Trans } from "@coworker/locales";
import taskStateOptions from "@coworker/enums/taskState";
import { useUserId } from "../../../core/auth/useLoggedInUser";
import trackerHelper from "../../../helpers/tracker";

const Border = styled("div")`
  background: var(--grey150);
  height: 10px;
`;
const DetailSection = styled("div")`
  display: flex;
  flex-direction: column;
  font-size: 14px;
`;
const DetailSectionTop = styled("div")`
  margin: 0 29px;
  height: 90px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const DetailSectionBottom = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
`;

function Picking({ task, picking, setPicking }) {
  const handleToggle = () => {
    trackerHelper.task.trackCompletePickingOnlyToggle(!picking);
    setPicking(!picking);
  };
  const userId = useUserId();

  return (
    !task.picked &&
    task.state === taskStateOptions.ASSIGNED &&
    task.assigned_user_id === userId && (
      <>
        <Border />
        <DetailSection data-testid="pickingSection">
          <DetailSectionTop>
            <Trans>completePickingString</Trans>
            <FixaSwitch
              data-testid="pickingToggle"
              checked={picking}
              onChange={handleToggle}
              subtle
            />
          </DetailSectionTop>
          <DetailSectionBottom>
            {
              <Instructions
                title={<Trans>pickingOnlyString</Trans>}
                text={<Trans>pickingOnlyTextString</Trans>}
                type={profilePreferences.DISABLE_POPUPS_PICKING}
              />
            }
          </DetailSectionBottom>
        </DetailSection>
        <Border />
      </>
    )
  );
}

export default Picking;
